export default [
  {
    path: '/user/agreementPrivacy',
    component: () => import('../../views/user/agreementPrivacy.vue'),
    name: 'user.agreementPrvacy',
    meta: {
      auth: 0,
      title: '隐私协议',
      visibleShare: true,
    },
  },
  {
    path: '/orderConfirm',
    component: () => import('../../views/user/orderConfirm.vue'),
    name: 'orderConfirm',
    meta: {
      auth: 0,
      visibleShare: true,
      title: 'Order Confirmation',
      backgroundClass: 'bg-white',
    },
  },
  {
    path: '/mapOrderConfirm',
    component: () => import('../../views/user/mapOrderConfirm.vue'),
    name: 'mapOrderConfirm',
    meta: {
      auth: 0,
      visibleShare: true,
      title: 'Order Confirmation',
      backgroundClass: 'bg-white',
    },
  },
];
